import { render, staticRenderFns } from "./CMInsuranceList.vue?vue&type=template&id=0e948ffb"
import script from "./CMInsuranceList.vue?vue&type=script&lang=js"
export * from "./CMInsuranceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports